export const CATEGORY_DESCRIPTION_SECTIONS = {
  // Required sections
  titles: {
    id: 'titles',
    label: 'category.sections.titles',
    charCounterId: 'titles-char-count',
    statusId: 'status-titles',
    display: false,
    hideSlider: false,
    defaultIntensity: 1,
    customInput: false,
  },
  meta: {
    id: 'meta',
    label: 'category.sections.meta',
    charCounterId: 'meta-char-count',
    statusId: 'status-meta',
    display: false,
    hideSlider: false,
    defaultIntensity: 1,
    customInput: false,
  },
  h1: {
    id: 'h1',
    label: 'category.sections.h1',
    charCounterId: 'h1-char-count',
    statusId: 'status-h1',
    display: false,
    hideSlider: false,
    defaultIntensity: 1,
    customInput: false,
  },
  // Slider sections
  new_users: {
    id: 'new_users',
    label: 'category.sections.new_users',
    sliderId: 'new_users-slider',
    charCounterId: 'new_users-char-count',
    statusId: 'status-new_users',
    display: true,
    hideSlider: false,
    defaultIntensity: 1,
    customInput: false,
  },
  advanced_users: {
    id: 'advanced_users',
    label: 'category.sections.advanced_users',
    sliderId: 'advanced_users-slider',
    charCounterId: 'advanced_users-char-count',
    statusId: 'status-advanced_users',
    display: true,
    hideSlider: false,
    defaultIntensity: 1,
    customInput: false,
  },
  buying_guide: {
    id: 'buying_guide',
    label: 'category.sections.buying_guide',
    sliderId: 'buying_guide-slider',
    charCounterId: 'buying_guide-char-count',
    statusId: 'status-buying_guide',
    display: true,
    hideSlider: false,
    defaultIntensity: 1,
    customInput: false,
  },
  faq_section: {
    id: 'faq_section',
    label: 'category.sections.faq_section',
    sliderId: 'faq_section-slider',
    charCounterId: 'faq_section-char-count',
    statusId: 'status-faq_section',
    display: true,
    hideSlider: false,
    defaultIntensity: 1,
    customInput: false,
  },
  benefits: {
    id: 'benefits',
    label: 'category.sections.benefits',
    sliderId: 'benefits-slider',
    charCounterId: 'benefits-char-count',
    statusId: 'status-benefits',
    display: true,
    hideSlider: false,
    defaultIntensity: 1,
    customInput: false,
  },
  trends: {
    id: 'trends',
    label: 'category.sections.trends',
    sliderId: 'trends-slider',
    charCounterId: 'trends-char-count',
    statusId: 'status-trends',
    display: true,
    hideSlider: false,
    defaultIntensity: 1,
    customInput: false,
  },
  usage_tips: {
    id: 'usage_tips',
    label: 'category.sections.usage_tips',
    sliderId: 'usage_tips-slider',
    charCounterId: 'usage_tips-char-count',
    statusId: 'status-usage_tips',
    display: true,
    hideSlider: false,
    defaultIntensity: 1,
    customInput: false,
  },
  glossary: {
    id: 'glossary',
    label: 'category.sections.glossary',
    sliderId: 'glossary-slider',
    charCounterId: 'glossary-char-count',
    statusId: 'status-glossary',
    display: true,
    hideSlider: false,
    defaultIntensity: 1,
    customInput: false,
  },
  comparative: {
    id: 'comparative',
    label: 'category.sections.comparative',
    sliderId: 'comparative-slider',
    charCounterId: 'comparative-char-count',
    statusId: 'status-comparative',
    display: true,
    hideSlider: false,
    defaultIntensity: 1,
    customInput: false,
  },
  did_you_know: {
    id: 'did_you_know',
    label: 'category.sections.did_you_know',
    sliderId: 'did_you_know-slider',
    charCounterId: 'did_you_know-char-count',
    statusId: 'status-did_you_know',
    display: true,
    hideSlider: false,
    defaultIntensity: 1,
    customInput: false,
  },
  care_tips: {
    id: 'care_tips',
    label: 'category.sections.care_tips',
    sliderId: 'care_tips-slider',
    charCounterId: 'care_tips-char-count',
    statusId: 'status-care_tips',
    display: true,
    hideSlider: false,
    defaultIntensity: 1,
    customInput: false,
  },
  social_impact: {
    id: 'social_impact',
    label: 'category.sections.social_impact',
    sliderId: 'social_impact-slider',
    charCounterId: 'social_impact-char-count',
    statusId: 'status-social_impact',
    display: true,
    hideSlider: false,
    defaultIntensity: 1,
    customInput: false,
  },
  environmental: {
    id: 'environmental',
    label: 'category.sections.environmental',
    sliderId: 'environmental-slider',
    charCounterId: 'environmental-char-count',
    statusId: 'status-environmental',
    display: true,
    hideSlider: false,
    defaultIntensity: 1,
    customInput: false,
  },
  brand: {
    id: 'brand',
    label: 'category.sections.brand',
    sliderId: 'brand-slider',
    charCounterId: 'brand-char-count',
    statusId: 'status-brand',
    display: true,
    hideSlider: false,
    defaultIntensity: 1,
    customInput: false,
  },
  customer_reviews: {
    id: 'customer_reviews',
    label: 'category.sections.customer_reviews',
    sliderId: 'customer_reviews-slider',
    charCounterId: 'customer_reviews-char-count',
    statusId: 'status-customer_reviews',
    display: true,
    hideSlider: false,
    defaultIntensity: 1,
    customInput: false,
  },
  // User input sections
  staff_favorites: {
    id: 'staff_favorites',
    label: 'category.sections.staff_favorites',
    sliderId: 'staff_favorites-slider',
    charCounterId: 'staff_favorites-char-count',
    statusId: 'status-staff_favorites',
    display: true,
    hideSlider: true,
    defaultIntensity: 5,
    customInput: true,
  },
  top_picks: {
    id: 'top_picks',
    label: 'category.sections.top_picks',
    sliderId: 'top_picks-slider',
    charCounterId: 'top_picks-char-count',
    statusId: 'status-top_picks',
    display: true,
    hideSlider: true,
    defaultIntensity: 5,
    customInput: true,
  },
};

export const CATEGORY_DESCRIPTION_SECTION_KEYS = Object.keys(CATEGORY_DESCRIPTION_SECTIONS);

// Section configuration for generated content display
export interface ContentSection {
  key: string;
  title: string;
  isTextSection: boolean;
}

/**
 * Generates content sections dynamically based on CATEGORY_DESCRIPTION_SECTIONS
 * @returns Array of ContentSection objects with translation paths for titles
 */
export const generateContentSections = (): ContentSection[] => {
  return Object.keys(CATEGORY_DESCRIPTION_SECTIONS).map((key) => {
    const section =
      CATEGORY_DESCRIPTION_SECTIONS[key as keyof typeof CATEGORY_DESCRIPTION_SECTIONS];

    // Determine if it's a text section based on section properties
    // Text sections are typically those with customInput or specific sections like titles, meta, h1
    const isTextSection =
      section.customInput ||
      ['titles', 'meta', 'h1', 'staff_favorites', 'top_picks', 'brand'].includes(key);

    return {
      key,
      title: `category.generated.${key}`,
      isTextSection,
    };
  });
};

export const DEFAULT_PROMPTS = {
  levels: {
    0: {
      prompt: 'Do not generate content',
      description: 'prompts.levels.0',
    },
    1: {
      prompt: 'Provide a single sentence with basic information about this aspect of the category.',
      description: 'prompts.levels.1',
    },
    2: {
      prompt:
        'Write a short paragraph covering essential information about this aspect of the category.',
      description: 'prompts.levels.2',
    },
    3: {
      prompt:
        'Create a moderate-length section about this aspect of the category, covering main points and basic details.',
      description: 'prompts.levels.3',
    },
    4: {
      prompt:
        'Write a detailed section about this aspect of the category, including specific examples and practical information.',
      description: 'prompts.levels.4',
    },
    5: {
      prompt:
        'Generate comprehensive content about this aspect of the category, including detailed examples, practical applications, and expert insights.',
      description: 'prompts.levels.5',
    },
  },
};
